import {
  Button,
  Pagination,
  Tabbar,
  TabbarItem,
  Textarea,
  Notify,
  Dialog,
  Sticky,
  Popup,
  Overlay,
  Cell,
  Divider,
  Card,
  Row,
  Col,
  Form,
  CellGroup,
  FormItem,
  InputNumber,
  Cascader,
  Input,
  Menu,
  MenuItem,
  Navbar,
  Tag,
  Tabs,
  TabPane,
  List,
  Radio,
  RadioGroup,
  Empty,
  Toast,
  Popover,
  DatePicker,
  Picker,
  Uploader,
  Checkbox,
  Progress,
  CheckboxGroup,
  InfiniteLoading,
  Video,
  Calendar,
  Collapse,
  CollapseItem,
  showToast,
  showNotify,
  showDialog,
  Searchbar,
  PullRefresh,
  Swiper,
  SwiperItem,
  Switch,
  Address,
  Table,
  Steps,
  Step,
  Backtop,
  NumberKeyboard,
  CalendarCard,
  Image,
  ActionSheet,
  ImagePreview
} from '@nutui/nutui'
export default (App) => {
  return [
    CalendarCard,
    NumberKeyboard,
    Address,
    Sticky,
    Switch,
    Swiper,
    SwiperItem,
    Button,
    Pagination,
    Tabbar,
    TabbarItem,
    Textarea,
    Notify,
    Dialog,
    Popup,
    Overlay,
    Cell,
    Divider,
    Card,
    Row,
    Col,
    Form,
    CellGroup,
    FormItem,
    InputNumber,
    Cascader,
    Input,
    Menu,
    MenuItem,
    Navbar,
    Tag,
    Tabs,
    TabPane,
    List,
    Radio,
    RadioGroup,
    Empty,
    Toast,
    Popover,
    DatePicker,
    Picker,
    Uploader,
    Checkbox,
    Progress,
    CheckboxGroup,
    InfiniteLoading,
    Video,
    Calendar,
    Collapse,
    CollapseItem,
    Searchbar,
    PullRefresh,
    Switch,
    Steps,
    Step,
    Table,
    Backtop,
    Image,
    ActionSheet,
    ImagePreview
  ].forEach((component) => {
    App.config.globalProperties.$notice = showNotify
    App.config.globalProperties.$dialog = showDialog
    App.config.globalProperties.$toast = showToast
    App.use(component)
  })
}
